import React, { createContext, useEffect, useState } from "react";
import { userManager } from "../auth/authConfig";

export const AuthContext = createContext({
  user: null,
  isLoading: true,
  isAuthenticated: false,
  role: null,
  login: () => {},
  // loginWithPassword: async () => {}, // Deshabilitado
  logout: () => {},
});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  
  


  useEffect(() => {
    // --- BYPASS DE AUTH PARA DESARROLLO ---
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get("Test") === "1") {
      const mockUser = {
        profile: {
          sub: "test-user-id",
          name: "Alan",
          role: "admin", // Asumimos rol de admin para el test
          preferred_username: "test@example.com",
          roles: ["admin"] // Por si acaso usa 'roles'
        },
        access_token: "mock-access-token",
        expired: false,
        expires_at: Math.floor(Date.now() / 1000) + 3600 // 1 hora
      };
      setUser(mockUser);
      setIsLoading(false);
      return; 
    }
    // --------------------------------------

    // Intentar cargar usuario existente al iniciar
    userManager.getUser().then((loadedUser) => {
      if (loadedUser && !loadedUser.expired) {
        setUser(loadedUser);
      }
      setIsLoading(false);
    });

    // Suscribirse a eventos de OIDC
    const onUserLoaded = (loadedUser) => setUser(loadedUser);
    const onUserUnloaded = () => setUser(null);
    const onUserSignedOut = () => {
      setUser(null);
    };
    const onAccessTokenExpiring = () => {
      console.warn("Access token expiring");
    };
    const onAccessTokenExpired = () => {
      console.warn("Access token expired");
      setUser(null);
    };

    userManager.events.addUserLoaded(onUserLoaded);
    userManager.events.addUserUnloaded(onUserUnloaded);
    userManager.events.addAccessTokenExpiring(onAccessTokenExpiring);
    userManager.events.addAccessTokenExpired(onAccessTokenExpired);
    userManager.events.addUserSignedOut(onUserSignedOut);

    return () => {
      userManager.events.removeUserLoaded(onUserLoaded);
      userManager.events.removeUserUnloaded(onUserUnloaded);
      userManager.events.removeAccessTokenExpiring(onAccessTokenExpiring);
      userManager.events.removeAccessTokenExpired(onAccessTokenExpired);
      userManager.events.removeUserSignedOut(onUserSignedOut);
    };
  }, []);

  const login = (redirectPath) =>
    userManager.signinRedirect(redirectPath ? { state: { returnUrl: redirectPath } } : undefined);
  

  // Función auxiliar para extraer el rol del token (depende de tu proveedor)
  // Ajusta 'role', 'roles', 'realm_access.roles', etc. según tu token
  const getRole = () => {
    if (!user || user.expired) return "invitado";
    // OJO: Revisar nombre exacto de campo rol en tu JWT
    const profile = user.profile || {};
    return profile.role || profile.roles || profile.realm_access?.roles || "admin"; // Ajuste temporal
  };

  const value = {
    user,
    isLoading,
    isAuthenticated: !!user && !user.expired,
    role: getRole(), 
    authError: null,
    login, // Login redirect standard — acepta redirectPath opcional
    // loginWithPassword, // COMENTADO: Servidor no soporta grant type password
    logout: () => userManager.signoutRedirect(), // Logout completo (redirige al servidor)
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
